module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.0c22c1f8.webp";